import axios from "axios";

const QrService = axios.create({
  baseURL: "https://esystems.cdl.lk/backend/AttendMe2/attme/",
  //  baseURL: "http://localhost:51976/attme/",
  headers: {
    UserId: "DTSUSER",
    Password: "Dts@10099",
  },
});


QrService.interceptors.request.use(
  (config) => {
    const employeeId = localStorage.getItem("employeeId");  

    if (employeeId) {
      config.headers.loggedUser = employeeId;  
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default QrService;



// import axios from "axios";

// const apiService = {
//   getJob: (date, serviceNo, location) =>
//     axios.get(
//       `attme/GetGroupAttendance?date=${date}&serviceNo=${serviceNo}&location=${location}`,
//       {
//         headers: {
//           UserId: "DTSUSER",
//           Password: "Dts@10099",
//         },
//       }
//     ),

// };

// export default apiService;